import { observer, useLocalObservable } from "mobx-react";
import TopTabs from "../HomePage/component/TopTabs";
import React, { useEffect, useState } from "react";
import AdviceTimelinePageListView from "./AdviceTimelinePageListView";
import AdviceTimelinePageStore from "./store/AdviceTimelinePageStore";
import EvalHeader from "./component/EvalHeader";
import Sidebar from "./component/Sidebar";
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/material";

interface Props {
  pageStore: AdviceTimelinePageStore;
}

function AdviceTimelinePage({ pageStore }: Props) {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // pageStore.fetchGradeList();
    //console.log(location.state.employee);
    pageStore.setEmployee(location.state.employee);
  }, []);

  return (
    <>
      {/* <TopTabs /> */}
      <Grid style={{ paddingBottom: "80px" }}>
        <AdviceTimelinePageListView pageStore={pageStore} />
      </Grid>
      <Sidebar showModal={showModal} setShowModal={setShowModal} />
    </>
  );
}

export default observer(AdviceTimelinePage);
